<div class="profile-personalisation-container">
    <label class="control-label">{{'SB_Personalisation_Embedded_Video_Background_Label' | translate}}</label>
    <div class="bg-options">
        <label *ngFor="let option of videoBackgroundOptions">
            <input type="radio" name="background" [value]="option.id"
                [checked]="option.id === selectedBackgroundOptionId" (change)="onBackgroundChange(option)" />
            <img [src]="cdnBase + option.imagePath" alt="" class="bg-thumbnail" />
        </label>
    </div>

    <div class="footer">
        <button 
            class="btn btn-success" 
            type="button" 
            (click)="save()"
            [disabled]="!selectedBackgroundOptionId">
            <sb-icon *ngIf="isSaving" name="loading"></sb-icon>
            <span *ngIf="!isSaving">{{'SB_Save' | translate}}</span>
        </button>
    </div>
</div>